export function getEnvVar<T extends string>(key: string): T {
  if (import.meta.env[key] === undefined) {
    throw new Error(`Environment variable ${key} is not defined`);
  }

  return import.meta.env[key];
}
